/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_No_Events_To_ExportInputs */

const en_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events found to export`)
};

const fr_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun evenement a exporter`)
};

const de_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine zu exportierenden Ereignisse gefunden.`)
};

const it_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun evento trovato da esportare`)
};

const ru_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События для экспорта не найдены.`)
};

const es_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron eventos para exportar`)
};

const zh_cn2_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到要导出的事件`)
};

const ja_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートするイベントが見つかりません`)
};

const hi_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात करने के लिए कोई इवेंट नहीं मिले`)
};

const pt_pt2_image_export_no_events_to_export = /** @type {(inputs: Image_Export_No_Events_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento encontrado para exportar.`)
};

/**
* | output |
* | --- |
* | "No events found to export" |
*
* @param {Image_Export_No_Events_To_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_no_events_to_export = /** @type {((inputs?: Image_Export_No_Events_To_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_No_Events_To_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_no_events_to_export(inputs)
	if (locale === "de") return de_image_export_no_events_to_export(inputs)
	if (locale === "it") return it_image_export_no_events_to_export(inputs)
	if (locale === "ru") return ru_image_export_no_events_to_export(inputs)
	if (locale === "es") return es_image_export_no_events_to_export(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_no_events_to_export(inputs)
	if (locale === "ja") return ja_image_export_no_events_to_export(inputs)
	if (locale === "hi") return hi_image_export_no_events_to_export(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_no_events_to_export(inputs)
	return en_image_export_no_events_to_export(inputs)
});